import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import prodDetail from './products_details.json';
import { If, Then, ElseIf, Else } from 'react-if-elseif-else-render';
import PreLoginPage from '../../../views/core/PreLoginPage';
import HmAjax from '../../../util/HmAjax';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import TestTakingModalComponent from '../../../views/plp/TestTakingModalComponent';
import BillingForm from '../../../views/purchase/BillingForm';
import NativeAjax from '../../../util/NativeAjax';
// ES6 class-style
class BuyOption extends PreLoginPage {

	constructor(props) {
	    super(props);
	    this.state = {
	      products_details: {},
				OPSAvailable:false,
				ModalShow:false,
				review_order:false,
				BillingFormShow:false
	    }
	    this.productDetails = localStorage.getItem('proDetail');
	    this.gradeID = localStorage.getItem('grade');
			this.proID = localStorage.getItem('product');
			this.url = this.gradeID+'.json';
			this.freetrailtextFn=this.freetrailtextFn.bind(this);

			this.role= props.role || '';
			this.showBillingForm = this.showBillingForm.bind(this);
			this.renderbillingForm = this.renderbillingForm.bind(this);
			this.showOrderReview = this.showOrderReview.bind(this);
			this.hideBillingModal=this.hideBillingModal.bind(this);
			this.hideReviewModal = this.hideReviewModal.bind(this);

			this.productsJson = {};
			this.purchaseObj = {};

			//init default to 30
			this.freeTrialDays = (!isNaN(window.free_trial_extension.days) && window.free_trial_extension.days > 0) ? window.free_trial_extension.days : 30; 
			//Decide the date until the product can be tried
			this.freeTrialDate = (!isNaN(window.free_trial_extension.date) && window.free_trial_extension.date > 0 ) ? new Date(window.free_trial_extension.date*1000) : new Date();
			//Default the toggle to days
			this.freeTrialToggle = (window.free_trial_extension && window.free_trial_extension.toggle) ? window.free_trial_extension.toggle : "days";
			
	  }
	componentWillMount(){		
		var me =this;
		  var callBackSuccess = function(response){
			if(response !== null){
				if (response.status === 'active') {
					me.setState({OPSAvailable:true});
				}
			}
	
			//console.log("OPS_DETECT response : ", response);
		}
	
		var callBackFailure = function(response){			
			console.log("Error in OPS_DETECT");		
		}
	
		new HmAjax(this.getUrlFor("OPS_DETECT")).get(callBackSuccess,callBackFailure);
	}
	componentDidMount() {
		var me = this;
		this.proID = localStorage.getItem('product');

		if(this.role=="TCHR"){
			try{
				me.tchrgetProductDetails();
			}catch(e){}
		}
	}

	tchrgetProductDetails(){
		var me = this;
		var callBackSuccess = function(response){
			if(response!==null){
				me.productsJson = response;
				var sortedProducts = me.sortTeacherProducts(response);
				me.purchaseObj=sortedProducts[0];
        //console.log("tchr products ",me.purchaseObj);
			}
		}

		var callBackFailure = function(response){		
			console.log("Error in PRODUCT_DETAILS");		
		}
		
		new NativeAjax(this.getUrlFor("PC1_PRODUCTS")).enableCORS().get(callBackSuccess,callBackFailure);
	}

	sortTeacherProducts(data){
		var products = (data && data.productList && data.productList.length > 0) ? data.productList : [];
		var tchrProducts = [];
		var filterProductCategories = window.teacherProducts || [];

		var appName = data.appName;
		var appId = data._appId;
	
		if(products.length > 0){
			for(let i=0;i<products.length;i++){
			if(filterProductCategories && filterProductCategories.length > 0 && filterProductCategories.indexOf(products[i].productCategory) > -1){
				products[i]["appName"] = appName;
				products[i]["appId"] = appId;
				tchrProducts.push(products[i]);
			}else if((!filterProductCategories || filterProductCategories.length == 0) && !isNaN(products[i].productCategory)){
				products[i]["appName"] = appName;
				products[i]["appId"] = appId;
				tchrProducts.push(products[i]);
			}
		}
		}
		return tchrProducts;
	 }

	getProductDetails(){
		//console.log(JSON.parse(this.productDetails));
	    if(this.productDetails != {} && this.productDetails != undefined){
	      return JSON.parse(this.productDetails);
	    }
	}

	epochTimeFn = (str,repTxt='') => {
		let replaceTxt = repTxt;
		let timeVal = replaceTxt;
		if(str>0){
		  var d = str; //new Date(Number(str) * 1000);
		  var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		  var n = (d.toDateString());
		  timeVal = d.getDate() +" "+ months[d.getMonth()] +"  "+d.getFullYear(); //n.substring(4,n.length);
		}
		return timeVal;
	}

	freetrailtextFn(){
		if(this.props.triedFree){
			return this.rb("product.freetrial.accessed");
		}

		var classname = this.getProductDetails()[this.proID].ClassName;
		if(classname == "Class 1" || classname == "Class 2" || classname == "Class 3" || classname == "Class 4"){
			if(this.freeTrialToggle === "date"){
				return this.rb('product.buyoption.freetrail.until').replace("{0}", this.epochTimeFn(this.freeTrialDate));
			}

			return this.rb('product.buyoption.freetrail').replace("{0}", this.freeTrialDays);
		}else{
			if(this.freeTrialToggle === "date"){
				return this.rb('product.buyoption.freetrail.until').replace("{0}", this.epochTimeFn(this.freeTrialDate));
			}

			return this.rb('product.buyoption.freetrail').replace("{0}", this.freeTrialDays);
		}
	}

	getFreeBtnDisabledClass(styles){
		return (this.props.triedFree || this.props.purchased) ? styles+" opsdisabled" : styles;
	}

	renderFreeTrailProductElement(data,tarrifid,index){
		var freeTrailBuyMsg = "Take away the hassle of going for TUITIONS";
		var tboxcontentclass = "tboxcontent";
		
		var classname = this.getProductDetails()[this.proID].ClassName;
		
		try{
			if(classname == "Class 1" || classname == "Class 2" || classname == "Class 3" || classname == "Class 4"){
				tboxcontentclass = "tboxcontentlarge";
				freeTrailBuyMsg = "Success in Maths is all about developing good work habits, persevering and taking responsibility for your learning";
			}else if(classname == "Class 9" || classname == "Class 10"){
				freeTrailBuyMsg = "Take diagnostic tests and bridge your learning gaps";
			}else{
				freeTrailBuyMsg = "Take diagnostic tests and bridge your learning gaps";
			}
		}catch(e){}
			
		
		var category = this.getProductDetails()[this.proID].productCategory;
		var category_ga = this.getProductDetails()[this.proID].productCategory;
		if(category_ga == "EXAM_PREP_CBSE"){
			category_ga = "CBSE Exam Prep";
		}
		 if(data.is_trial === true){
			 if(this.props.simpleform == "true"){
				 return (
	        		<div className='col-md-6 mb-10' key={index}>				  		
				  			<a data-ga={category_ga+" - "+classname+" - Top - Free Trial"} href="#" className={this.getFreeBtnDisabledClass("r-btn col-12 btn_freetrail")} data-freetrail="true" data-tarrifid={tarrifid} data-productid={this.proID} data-gradeid={this.gradeID} data-category={category} onClick={this.props.showSubScripeLoginForm}>{this.freetrailtextFn()}</a>				  		
				  	</div>
	        	);
			 }else{
	        	return (
	        		<div className="col-md-6" key={index}>
				  		<div className="t-box left">
				  			<div className={tboxcontentclass}>
				  				<h4 className="width100p">{freeTrailBuyMsg}</h4>	
				  			</div>
				  			<a data-ga={category_ga+" - "+classname+" - Bottom - Free Trial"} href="#" className={this.getFreeBtnDisabledClass("r-btn notexttransform btn_freetrail")} data-freetrail="true" data-tarrifid={tarrifid} data-productid={this.proID} data-gradeid={this.gradeID} data-category={category} onClick={this.props.showSubScripeLoginForm}>{this.freetrailtextFn()}</a>
				  		</div>
				  	</div>
	        	);
			}
        }
	}
	renderPaidProductElement(data,tarrifid,index){
		 if(data.is_trial === true){        	
        }else{        	
        	var classname = this.getProductDetails()[this.proID].ClassName;        	
        	var category = this.getProductDetails()[this.proID].productCategory;
        	var category_ga = this.getProductDetails()[this.proID].productCategory;
			if(category_ga == "EXAM_PREP_CBSE"){
				category_ga = "CBSE Exam Prep";
			}
		
        	var price = 0;
        	var monthprice = 0;
        	var tboxcontentclass = "tboxcontent";
        	try{
        		price = parseInt(Math.round(data.productPrice));
        		monthprice = Math.round(price/12);
        	}catch(e){}
        	
        	
        	var paidBuyMsg = "No more hassle of going for tuitions";
        	try{
				if(classname == "Class 1" || classname == "Class 2" || classname == "Class 3" || classname == "Class 4"){
					tboxcontentclass = "tboxcontentlarge";
					paidBuyMsg = "Mom, you can be the best coach for your child. <br /><span class='buysmallinfo'>Create bonding moments over Math</span>";
				}
			}catch(e){}
		
        	
        	//console.log("category:::",category);
        	
        	 if(this.props.simpleform == "true"){
				 return (
	        		<div className="col-md-6" key={index}>				  		
			  			 {(() => {											
		    		        if(this.state.OPSAvailable){
		    		        	return (<a data-ga={category_ga+" - "+classname+" - Top - Subscribe now"} href="#" className="r-btn opsenabled col-12 btn_subscribe" data-freetrail="false" data-tarrifid={tarrifid} data-productid={this.proID} data-gradeid={this.gradeID} data-category={category} onClick={this.props.showSubScripeLoginForm}>SUBSCRIBE NOW</a>);
		    		        }else{						    		        	
			    		        return (<a data-ga={category_ga+" - "+classname+" - Top - Subscribe now"} href="#" className="r-btn opsdisabled col-12 btn_subscribe" data-freetrail="false" data-tarrifid={tarrifid} data-productid={this.proID} data-gradeid={this.gradeID} data-category={category} onClick={this.props.showSubScripeLoginForm}>SUBSCRIBE NOW</a>);							    		       
		    		        }
		    		      })()}	
		    		      <h3 className="pt-10 pricetxt"><strong><i className="fa">&#xf156;</i> {monthprice} / month <span className="smalltxt">Billed annually</span></strong></h3>
				  	</div>
	        	);
			 }else{
				 
				  return (
		        	<div className="col-md-6" key={index}>
				  		<div className="t-box right">
				  				<div className={tboxcontentclass}>
				  					<h4>{ReactHtmlParser(paidBuyMsg)}</h4>
				  					
				  					<h3 className="pt-30"><strong><i className="fa">&#xf156;</i> {monthprice} / month </strong></h3>
				  					<div><span className="font1rem">Billed annually</span></div>
								</div>
								 {(() => {											
				    		        if(this.state.OPSAvailable){
				    		        	return (<a data-ga={category_ga+" - "+classname+" - Bottom - Subscribe now"} href="#" className="r-btn opsenabled btn_subscribe" data-freetrail="false" data-tarrifid={tarrifid} data-productid={this.proID} data-gradeid={this.gradeID} data-category={category} onClick={this.props.showSubScripeLoginForm}>JOIN THE HEYMATH! CLUB</a>);
				    		        }else{						    		        	
					    		        return (<a data-ga={category_ga+" - "+classname+" - Bottom - Subscribe now"} href="#" className="r-btn opsdisabled btn_subscribe" data-freetrail="false" data-tarrifid={tarrifid} data-productid={this.proID} data-gradeid={this.gradeID} data-category={category} onClick={this.props.showSubScripeLoginForm}>JOIN THE HEYMATH! CLUB</a>);							    		       
				    		        }
				    		      })()}	
								 
				  			
				  		</div>
				  	</div>
		        );		
			 }
	       					    		       
        }
	}


	showBillingForm(){
		this.setState({BillingFormShow:true,ModalShow:true});
 }

	hideBillingModal(){
		this.setState({ModalShow:false});
	}

	showOrderReview(){
		this.setState({review_order:true});
	}

	hideReviewModal(){
		this.setState({review_order:false});
	}


renderbillingForm(){
	//console.log("renderbilling Form ",this.state.ModalShow);
	return (
			<div>
					<TestTakingModalComponent visible={this.state.ModalShow} dialogClassName="modal-md">
					<div className="loginHeader text-center">	
					<div className="text-center modallogo loginHeaderTxt">
					{this.rb("billing.information")}
					</div>
					<div className="close loginClose" onClick={this.hideBillingModal}  aria-label="Close">
					<span aria-hidden="true"><i className="material-icons">close</i></span>
					</div>
					</div>
					<div className="modal-body">
					<BillingForm purchaseObj={this.purchaseObj} productsJson={this.productsJson} myProps={this.props}  ModalShow={this.state.ModalShow} showBillingForm={this.showBillingForm} hideBillingModal={this.hideBillingModal} review_order={this.state.review_order} showOrderReview={this.showOrderReview} hideReviewModal={this.hideReviewModal} purchaseKey={this.state.purchaseKey} />
					</div>							
					</TestTakingModalComponent>
					</div>
	)
}

  render() {
		var monthprice=416;
  if(this.role==="TCHR"){
return(
	<div>
		<div className="container">
					  <div className="row col-10 mx-auto simplebuycontainer">
		
					  <div className='col-md-6 mb-10'>				  		
				  			<a href="#" className={this.getFreeBtnDisabledClass("r-btn col-12 btn_freetrail")} onClick={this.props.showContactus}>{this.rb("Teachers.freetrail")}</a>				  		
				  	</div>
						
						<div className="col-md-6">				  		
			  			 {(() => {											
		    		        if(this.state.OPSAvailable){
		    		        	return (<a href="#" className="r-btn opsenabled col-12 btn_subscribe" onClick={this.showBillingForm}>{this.rb("Teachers.subscribe")}</a>);
		    		        }else{						    		        	
			    		        return (<a href="#" className="r-btn opsdisabled col-12 btn_subscribe" onClick={this.showBillingForm}>{this.rb("Teachers.subscribe")}</a>);							    		       
		    		        }
		    		      })()}	
		    		      <h3 className="pt-10 pricetxt"><strong><i className="fa">&#xf156;</i> {monthprice} / month <span className="smalltxt">Billed annually</span></strong></h3>
				  	</div>

					 </div>
					{
						(() => {
								if(this.state.BillingFormShow && this.purchaseObj!==undefined){
									return this.renderbillingForm()
								}
						})()
					}
				</div>
	</div>
)
	}else{
		this.proID = localStorage.getItem('product');  	
  	const buy = this.getProductDetails()[this.proID].pricing_details;

  	var myObj;
  	//console.log(buy);

  	var newArr = Object.keys(buy);
	//console.log(newArr);

	/*var mappedArr = newArr.map(function(i) {
	  console.log(buy[i].productPrice);
	});*/

	if(this.props.simpleform == "true"){
		return(
				<div className="container">
					  <div className="row col-10 mx-auto simplebuycontainer">
			
					    {Object.keys(buy).map((v, i) => 
					  				this.renderFreeTrailProductElement(buy[v],v,i)
								)
						}

					    {(() => {
					    	if(!window.suppress_all_paid_products){
					    	return Object.keys(buy).map((v, i) => 
					  		this.renderPaidProductElement(buy[v],v,i)
							)
					    	}
					    })()}

					 </div>
				</div>
		);
	}else{
	  	return(
			<div className=""> 
				<div className="container">
					  <div className="row">
		
					  	{Object.keys(buy).map((v, i) => 
					  		this.renderFreeTrailProductElement(buy[v],v,i)
						)}

						  {(() => {
					    	if(!window.suppress_all_paid_products){
					    	return Object.keys(buy).map((v, i) => 
					  		this.renderPaidProductElement(buy[v],v,i)
						)
					    	}
					    })()}
						
					 </div>
				</div>
			</div>
	  	);
	}
  }
	}
}

export default BuyOption; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/BuyOption.js